import React from "react"

const AppLoading = () => {
  return (
    <div className={"grid-center"} style={{ height: "100vh" }}>
      <img className={"bounce"} src={"/assets/png/logo.png"} width={100} alt={"logo"} />
    </div>
  )
}

export default AppLoading
